import { render, staticRenderFns } from "./SupplierCorrespondenceB2b.vue?vue&type=template&id=51001a69&scoped=true&"
import script from "./SupplierCorrespondenceB2b.vue?vue&type=script&lang=js&"
export * from "./SupplierCorrespondenceB2b.vue?vue&type=script&lang=js&"
import style0 from "./SupplierCorrespondenceB2b.vue?vue&type=style&index=0&id=51001a69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51001a69",
  null
  
)

export default component.exports